import { SceneSuggestion, TransitionSuggestion } from '../type'

export const sceneSuggestions: SceneSuggestion[] = [{ title: 'EXT' }, { title: 'INT' }]

export const transitionSuggestions: TransitionSuggestion[] = [
    { title: 'Cut to' },
    { title: 'Fade in' },
    { title: 'Fade out' },
    { title: 'Dissolve to' },
    { title: 'Smash cut to' },
    { title: 'Match cut to' },
    { title: 'Fade to black' },
    { title: 'Time cut to' },
    { title: 'Jump cut to' },
    { title: 'Intercut with' },
    { title: 'Continuous' },
    { title: 'Later' },
    { title: 'Wipe to' },
    { title: 'Iris in' },
    { title: 'Iris out' },
]

export const shotSuggestions = {
    framingShots: [
        { title: 'Extreme close-up' },
        { title: 'Close-up' },
        { title: 'Medium close-up' },
        { title: 'Medium shot' },
        { title: 'Medium long shot' },
        { title: 'Long shot' },
        { title: 'Extreme long shot' },
        { title: 'Establishing shot' },
        { title: 'Master shot' },
        { title: 'Two-shot' },
    ],
    angleShots: [
        { title: 'High angle' },
        { title: 'Low angle' },
        { title: 'Overhead shot (bird’s eye)' },
        { title: 'Worm’s eye view' },
        { title: 'Dutch angle (tilt)' },
        { title: 'Over-the-shoulder (OTS)' },
        { title: 'Point of view (POV)' },
    ],
    movementShots: [
        { title: 'Pan' },
        { title: 'Tilt' },
        { title: 'Zoom in' },
        { title: 'Zoom out' },
        { title: 'Dolly' },
        { title: 'Crane shot' },
        { title: 'Tracking shot' },
        { title: 'Handheld shot' },
        { title: 'Steadicam shot' },
        { title: 'Whip pan' },
    ],
    insertAndCutShots: [
        { title: 'Insert shot' },
        { title: 'Cutaway' },
        { title: 'Reaction shot' },
        { title: 'Jump cut' },
        { title: 'Match cut' },
        { title: 'Smash cut' },
        { title: 'Split screen' },
    ],
    sequenceAndTimeShots: [{ title: 'Montage' }, { title: 'Flashback' }, { title: 'Flashforward' }],
}
